import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import sizes from 'constants/sizes';
import PublishTradingOfferModalHeader from './components/PublishTradingOfferModalHeader';
import PublishTradingOfferModalBody from './components/PublishTradingOfferModalBody';
import PublishTradingOfferModalFooter from './components/PublishTradingOfferModalFooter';
import PublishTradingOfferSuccessContent from './components/PublishTradingOfferSuccessContent';

import { usePublishTradingOfferModal } from './context/PublishTradingOfferModalContext';

const PublishTradingOfferModal: FC = () => {
  const { data } = usePublishTradingOfferModal();

  if (data.publishedOffer) {
    return (
      <>
        <PublishTradingOfferSuccessContent size={sizes.MD} />
      </>
    );
  }

  return (
    <>
      <PublishTradingOfferModalHeader />
      <PublishTradingOfferModalBody />
      <PublishTradingOfferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default PublishTradingOfferModal;
